const sizes = {
  sm: {
    lineHeight: '1.25rem',
  },
  md: {
    lineHeight: '1.25rem',
  },
  lg: {
    lineHeight: '1.25rem',
  },
  xl: {
    lineHeight: '1.6875rem',
  },
  xxl: {
    lineHeight: '2rem',
  },
};

export { sizes };
